<template>
  <menu-item v-slot="{ active, close }">
    <button type="button" class="block w-full px-2 text-left text-md">
      <span
        class="block rounded-lg px-2 py-2 text-gray-900"
        :class="[
          active && !selected
            ? 'bg-gray-50 '
            : !active && selected
              ? 'bg-gray-100 font-semibold'
              : active && selected
                ? 'bg-gray-50 font-semibold'
                : 'font-normal hover:bg-gray-50',
        ]"
      >
        <slot :close="close"></slot>
      </span>
    </button>
  </menu-item>
</template>

<script setup lang="ts">
import { MenuItem } from '@headlessui/vue';
defineProps({
  selected: {
    type: Boolean,
    default: false,
  },
});
</script>
